import {ICallBuiltInBackground} from '@toolify/client/src/modules/call/types/ICallBackground'

export const CALL_BUILT_IN_BACKGROUNDS: ICallBuiltInBackground[] = [
  {
    id: 'gradient-aurora',
    label: 'Aurora',
    kind: 'gradient',
    gradient: {
      angle: 135,
      stops: [
        {
          offset: 0,
          color: '#1e3a8a',
        },
        {
          offset: 50,
          color: '#6d28d9',
        },
        {
          offset: 100,
          color: '#0e7490',
        },
      ],
    },
  },
  {
    id: 'gradient-sunset',
    label: 'Sunset',
    kind: 'gradient',
    gradient: {
      angle: 135,
      stops: [
        {
          offset: 0,
          color: '#f59e0b',
        },
        {
          offset: 50,
          color: '#ec4899',
        },
        {
          offset: 100,
          color: '#7c3aed',
        },
      ],
    },
  },
  {
    id: 'gradient-mint',
    label: 'Mint',
    kind: 'gradient',
    gradient: {
      angle: 135,
      stops: [
        {
          offset: 0,
          color: '#22d3ee',
        },
        {
          offset: 100,
          color: '#10b981',
        },
      ],
    },
  },
  {
    id: 'gradient-graphite',
    label: 'Graphite',
    kind: 'gradient',
    gradient: {
      angle: 160,
      stops: [
        {
          offset: 0,
          color: '#374151',
        },
        {
          offset: 100,
          color: '#0f172a',
        },
      ],
    },
  },
  {
    id: 'gradient-ocean',
    label: 'Ocean',
    kind: 'gradient',
    gradient: {
      angle: 150,
      stops: [
        {
          offset: 0,
          color: '#0ea5e9',
        },
        {
          offset: 100,
          color: '#1e40af',
        },
      ],
    },
  },
  {
    id: 'gradient-lavender',
    label: 'Lavender',
    kind: 'gradient',
    gradient: {
      angle: 120,
      stops: [
        {
          offset: 0,
          color: '#c4b5fd',
        },
        {
          offset: 100,
          color: '#f0abfc',
        },
      ],
    },
  },
  {
    id: 'gradient-peach',
    label: 'Peach',
    kind: 'gradient',
    gradient: {
      angle: 135,
      stops: [
        {
          offset: 0,
          color: '#fbbf24',
        },
        {
          offset: 100,
          color: '#fb7185',
        },
      ],
    },
  },
  {
    id: 'gradient-forest',
    label: 'Forest',
    kind: 'gradient',
    gradient: {
      angle: 150,
      stops: [
        {
          offset: 0,
          color: '#4ade80',
        },
        {
          offset: 100,
          color: '#14532d',
        },
      ],
    },
  },
  {
    id: 'gradient-orchid',
    label: 'Orchid',
    kind: 'gradient',
    gradient: {
      angle: 160,
      stops: [
        {
          offset: 0,
          color: '#e879f9',
        },
        {
          offset: 100,
          color: '#6366f1',
        },
      ],
    },
  },
  {
    id: 'photo-office-meeting',
    label: 'Meeting room',
    kind: 'photo',
    url: '/static/images/call-backgrounds/photo-office-meeting.jpg',
  },
  {
    id: 'photo-office-conference',
    label: 'Conference room',
    kind: 'photo',
    url: '/static/images/call-backgrounds/photo-office-conference.jpg',
  },
  {
    id: 'photo-office-openspace',
    label: 'Open space',
    kind: 'photo',
    url: '/static/images/call-backgrounds/photo-office-openspace.jpg',
  },
  {
    id: 'photo-office-coworking',
    label: 'Coworking',
    kind: 'photo',
    url: '/static/images/call-backgrounds/photo-office-coworking.jpg',
  },
  {
    id: 'photo-office-lounge',
    label: 'Office lounge',
    kind: 'photo',
    url: '/static/images/call-backgrounds/photo-office-lounge.jpg',
  },
  {
    id: 'photo-office-desk',
    label: 'Desk by the window',
    kind: 'photo',
    url: '/static/images/call-backgrounds/photo-office-desk.jpg',
  },
]
